import React from 'react'

import { icons } from '../settings/RatingCriteriaIconOptions'

const RatingIcon = ({ iconName }) => {
  const Icon = icons[iconName]
  const iconProps = { style: { width: 15, height: 15 } }

  return Icon && <Icon {...iconProps} />
}

export default RatingIcon
